import type { ReactElement } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { ODSAlert, ODSButton, ODSLoginPortal } from 'bc-ods';
import { useLocation } from 'react-router-dom';
import { includeBasePath } from 'utils/url-utils';

const messages = defineMessages({
  loggedOut: {
    id: 'loggedOut.message',
    defaultMessage: 'You have been signed out.',
  },
  returnToLogin: {
    id: 'loggedOut.returnToLogin',
    defaultMessage: 'Return to login page',
  },
});

function LoggedOut(): ReactElement {
  const { search } = useLocation();
  const loginLink = includeBasePath(`/login${search}`); // preserve query params e.g. ?next=/brief/123

  return (
    <ODSLoginPortal data-testid="logout-form">
      <ODSAlert color="warning" className="mb-3">
        <FormattedMessage {...messages.loggedOut} />
      </ODSAlert>
      <ODSButton cta fullWidth link={loginLink} data-testid="go-to-login">
        <FormattedMessage {...messages.returnToLogin} />
      </ODSButton>
    </ODSLoginPortal>
  );
}

export default LoggedOut;
